// import "@fancyapps/fancybox/dist/jquery.fancybox.min.js";
/* 
  AOS
*/
import AOS from "aos";
AOS.init();
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 2000, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
});

/*
  Menu Function hover
*/
const menuItems = document.querySelectorAll(".ul-menu > li");
const subMenuItems = document.querySelectorAll(".ul-menu > li > ul > li");

var width =
  window.innerWidth > 0
    ? window.innerWidth
    : document.documentElement.clientWidth;
if (width > 991) {
  menuItems.forEach((item) => {
    item.addEventListener("mouseover", function (event) {
      const dropdown_menu = item.querySelector(".dropdown-menu");
      const overlay_gray = document.querySelector(".overlay-gray");
      if (dropdown_menu) {
        dropdown_menu.classList.add("activeMenu");
        overlay_gray.classList.add("overlay_gray_active");
      }
    });

    item.addEventListener("mouseleave", function (event) {
      const dropdown_menu = item.querySelector(".dropdown-menu");
      const overlay_gray = document.querySelector(".overlay-gray");
      if (dropdown_menu) {
        dropdown_menu.classList.remove("activeMenu");
        overlay_gray.classList.remove("overlay_gray_active");
      }
    });
  });
  subMenuItems.forEach((item) => {
    item.addEventListener("mouseover", function (event) {
      const dropdown_menu = item.querySelector(".dropdown-menu");
      const overlay_gray = document.querySelector(".overlay-gray");
      if (dropdown_menu) {
        dropdown_menu.classList.add("activeMenu");
        overlay_gray.classList.add("overlay_gray_active");
      }
    });

    item.addEventListener("mouseleave", function (event) {
      const dropdown_menu = item.querySelector(".dropdown-menu");
      const overlay_gray = document.querySelector(".overlay-gray");
      if (dropdown_menu) {
        dropdown_menu.classList.remove("activeMenu");
        overlay_gray.classList.remove("overlay_gray_active");
      }
    });
  });
} else {
  menuItems.forEach((item) => {
    item.addEventListener("click", function (e) {
      const dropdownToggle = item.querySelector(".dropdown-toggle");
      console.log(e.target.closest(".dropdown-toggle"));
      if (e.target.closest(".dropdown-toggle")) {
        console.log(dropdownToggle);
        const dropdown_menu = item.querySelector(".dropdown-menu");
        if (dropdown_menu) {
          dropdown_menu.classList.toggle("activeMenu");
        }
      }
    });

    // item.addEventListener("mouseleave", function (event) {
    //   const dropdown_menu = item.querySelector(".dropdown-menu");
    //   if (dropdown_menu) {
    //     dropdown_menu.classList.remove("activeMenu");
    //   }
    // });
  });

  subMenuItems.forEach((item) => {
    item.addEventListener("click", function (event) {
      const dropdown_menu = item.querySelector(".dropdown-menu");
      if (dropdown_menu) {
        dropdown_menu.classList.toggle("activeMenu");
      }
    });

    // item.addEventListener("mouseleave", function (event) {
    //   const dropdown_menu = item.querySelector(".dropdown-menu");
    //   const overlay_gray = document.querySelector(".overlay-gray");
    //   if (dropdown_menu) {
    //     dropdown_menu.classList.remove("activeMenu");
    //     overlay_gray.classList.remove("overlay_gray_active");
    //   }
    // });
  });


  /* 
  Menu Scroll Function
*/
const body = document.body;
const scrollDown = "scroll-down";
let lastScroll = 0;

window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (
    currentScroll > lastScroll &&
    !body.classList.contains(scrollDown) &&
    currentScroll >= 44
  ) {
    // down
    body.classList.add(scrollDown);
  } else if (
    currentScroll <= 44 &&
    body.classList.contains(scrollDown)
  ) {
    // up
    body.classList.remove(scrollDown);
  }

  lastScroll = currentScroll;
});
}

/* 
  Swiper Slider Config
*/
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
Swiper.use([Navigation, Pagination, Autoplay]);

new Swiper(".lastProduct", {
  slidesPerView: 2,
  spaceBetween: 15,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    668: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 15,
    },
    1700: {
      slidesPerView: 5,
      spaceBetween: 15,
    },
  },
});

new Swiper(".swiperCategory", {
  slidesPerView: 2,
  spaceBetween: 15,
  loopFillGroupWithBlank: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
  },
});

new Swiper(".relatedSwiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  loopFillGroupWithBlank: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 10,
    },
  },
});

new Swiper(".blogPost", {
  slidesPerView: 1,
  spaceBetween: 15,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

new Swiper(".mainSlider", {
  loop: true,
  slidesPerView: 1,
  speed: 1000,
  autoplay: {
    disableOnInteraction: false,
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

function customArchiveSwiper() {
  new Swiper(".customArchiveSwiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
customArchiveSwiper();

/*
  FAQ
*/
// const faqBtn = document.querySelectorAll(".faq-btn");
// faqBtn.forEach((faq) => {
//   faq.addEventListener("click", function (e) {
//     e.preventDefault();
//     e.target.closest(".faq-btn").parentNode.classList.toggle("faq-active");
//   });
// });

/*
  Hide notices woocommerce if empty
*/
let notices = document.querySelector(".woocommerce-notices-wrapper");
if (notices) {
  if (notices.childNodes.length === 0) {
    notices.classList.add("hidden");
  }
}

//Drawer
setTimeout(function () {
  let drawerLogin = document.querySelector("#drawer-login");
  drawerLogin ? drawerLogin.classList.remove("hidden") : "";

  let drawerCart = document.querySelector("#drawer-cart");
  drawerCart ? drawerCart.classList.remove("hidden") : "";

  let drawerSize = document.querySelector("#drawer-size");
  drawerSize ? drawerSize.classList.remove("hidden") : "";

  let drawerNavMobile = document.querySelector("#drawer-nav-mobile");
  drawerNavMobile ? drawerNavMobile.classList.remove("hidden") : "";

  let drawerFilter = document.querySelector("#drawer-filter");
  drawerFilter ? drawerFilter.classList.remove("hidden") : "";
}, 1000);

//Click ti btn cart for show drawer cart after click add to cart btn
jQuery(document).ready(function ($) {
  $("body").on("click", ".single_add_to_cart_button", function () {
    sessionStorage.setItem("addToCartClicked", "true");
  });

  if (sessionStorage.getItem("addToCartClicked")) {
    var cartButton = document.querySelector('[aria-label="cart"]');
    if (cartButton) {
      cartButton.click();
    }
    sessionStorage.removeItem("addToCartClicked");
  }
});

//Quantity Handler
let minus_quantity = document.querySelector(".minus_quantity");
let plus_quantity = document.querySelector(".plus_quantity");
let quantity_input = document.querySelector("[name='quantity']");
let min_quantity = 1; // Set your minimum value here

if (minus_quantity) {
  minus_quantity.addEventListener("click", function (e) {
    let current_value = parseInt(quantity_input.value);
    quantity_input.value =
      current_value > min_quantity ? current_value - 1 : min_quantity;
  });

  plus_quantity.addEventListener("click", function (e) {
    let current_value = parseInt(quantity_input.value);
    quantity_input.value = current_value + 1;
  });
}
